export const environment = {
    production: false,
    apiUrl: 'https://dev-public-1.datarails.com/api/plg',
    staticBaseUrl: 'https://dev-static.datarails.com',
    heapAppId: '',
    tryYourDataUrl: 'https://finance-brain-lab.base44.app/try-your-data',
    // Dev (``dev.tryit.financeos.com``): skip the HubSpot sign-up gate so
    // testers can land on the wizard without provisioning a HubSpot contact.
    // Paired with the backend ``plg__skip_hubspot_auth`` flag, which is
    // enabled by the LocalFeatureFlags default-True provider in DEV envs.
    plgAuthBypass: true,
    // Show the "GUIDED FLOWS" group in the chat input suggestions popover.
    // Off by default — guided flows are hidden from the suggested prompts.
    // Flip to true here to bring them back for testing.
    guidedFlowsEnabled: false,
    // Mixpanel project token (client-side, same visibility as heapAppId).
    // Injected at deploy time from the ``MIXPANEL_TOKEN`` variable on the selected
    // GitHub Environment (see ``.github/workflows/deploy.yml``). Empty string here =
    // analytics no-ops, e.g. local builds that don't run the deploy workflow.
    mixpanelToken: '86f93349c467b6119a78ef451f819478',
    // Hard-coded org identifier sent as the `org_id` Mixpanel super-property
    // (PLG trials have no real organization). Change to the agreed value.
    analyticsOrgId: 'PLG000000000000001',
};
